<template>
  <div v-if="parameter && parameterType">
    <span v-if="fallback" style="text-decoration: italic">fallback&#160;</span>
    <template v-if="!fallback && parameterCopy">
      <v-text-field
        :label="parameterType.name"
        type="number"
        v-model.number="parameterCopy.value"
        @input="updateParameterDebounce"
        outline
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="resetParameter()"
            v-on="on"
            color="error"
            small
            v-if="groupid"
          >
            <v-icon>settings_backup_restore</v-icon>Reset
          </v-btn>
        </template>
        <span>Forget this custom value and track the base price</span>
      </v-tooltip>
      <v-btn
        :to="{ name: 'quoteParameter', params: { id: parameter.id } }"
        small
      >
        <v-icon>launch</v-icon>
        <span>{{ parameterType.name }}</span>
      </v-btn>
    </template>
    <template v-if="fallback">
      <span>{{ parameter.value | toCurrency }}</span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="overrideParameter()" v-on="on" color="info" small
            >Override</v-btn
          >
        </template>
        <span>Stop tracking the base price and set a custom value</span>
      </v-tooltip>
      <v-btn
        :to="{ name: 'quoteParameter', params: { id: parameter.id } }"
        small
      >
        <v-icon>launch</v-icon>
        <span>{{ parameterType.name }}</span>
      </v-btn>
    </template>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Parameter",
  props: ["value", "groupid", "promotionid", "parameterTypesMap"],
  computed: {
    fallback() {
      return this.value && this.value.parameter ? false : true;
    },
    parameter() {
      return this.fallback
        ? this.value.parameterFallback
        : this.value.parameter;
    },
    parameterType() {
      return this.parameterTypesMap
        ? this.parameterTypesMap[this.parameter.parametertypeid]
        : undefined;
    }
  },
  data() {
    return {
      timerId: null,
      parameterCopy: null,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    updateParameterDebounce() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.updateParameter();
      }, 1000);
    },
    async updateParameter() {
      // console.log(this.parameterCopy);
      await nbmlaw.put(
        `/cors/admin/sales/parameters/${this.parameter.id}`,
        this.parameterCopy
      );
      // console.log(response.data);
      this.snackbar = true;
      this.snackbarText = `Parameter ${this.parameter.id} has been updated`;
      this.$emit("updated");
    },
    async resetParameter() {
      await nbmlaw.delete(
        `/cors/admin/sales/parameters/${this.parameter.id}/reset`,
        {
          params: { groupid: this.groupid, promotionid: this.promotionid }
        }
      );
      // console.log(response.data);
      this.$emit("updated");
    },
    async overrideParameter() {
      await nbmlaw.post(
        `/cors/admin/sales/parameters/${this.parameter.id}/override`,
        null,
        {
          params: { groupid: this.groupid, promotionid: this.promotionid }
        }
      );
      // console.log(response.data);
      this.$emit("updated");
    }
  },
  watch: {
    parameter: {
      immediate: true,
      handler() {
        this.parameterCopy = this.parameter
          ? JSON.parse(JSON.stringify(this.parameter))
          : null;
      }
    }
  }
};
</script>

<style></style>